const CXHTR_ERROR = "Error in BrowserRequestListener : ";
export const CXTR_ERROR_CALLBACK = CXHTR_ERROR + "Error while calling Callback";
export const CXTR_ERROR_APPLY_CALLED_MORE_THAN_ONCE = CXHTR_ERROR + "Apply method should be called once"; 